import { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContext from "../../AppContext";
import { setToggleWidget } from "../../widgetSlice";
import { motion, AnimatePresence } from "framer-motion";
import monaLogo from "../../../assets/mona-mascot-temp.png";
import { useFetch } from "../../../hooks/useFetch";
import primeClient from "../../../axios/primeClient";
import { useTranslation } from "react-i18next";

export const Launcher = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let toggleWidget = useSelector((state) => state.widgetState.toggleWidget);
  const appContext = useContext(AppContext);
  const { widgetColor, textColor } = appContext;
  const { data, isLoading, error } = useFetch({
    url: `/v1/apps/count`,
    client: primeClient,
  });

  // State to manage the visibility of the chat bubble
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
    // Show bubble after 0 seconds and hide it after 5 seconds
    const timer = setTimeout(() => setShowBubble(true), 0);

    const hideTimer = setTimeout(() => setShowBubble(false), 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.5 }}
        className={`fixed bottom-4 right-5 mr-1 inline-flex cursor-pointer items-center rounded-full text-center text-sm font-medium text-white xs:right-0`}
        style={{
          gap: "10px",
          bottom: "20px",
          right: "10px",
        }}
        onClick={(e) => {
          e.preventDefault();
          dispatch(setToggleWidget(!toggleWidget));
        }}
      >
        {/* Bubble with pointer */}
        {showBubble && (
          <div
            style={{
              position: "relative",
              backgroundColor: "#d4e0ee",
              color: "#333",
              padding: "10px 15px",
              borderRadius: "20px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
              fontSize: "14px",
              maxWidth: "200px",
              zIndex: 10000,
            }}
          >
            {!isLoading && !error ? (
              <div>
                {t("prime.bubbleChat1", {
                  down: data.devices_down,
                  attention: data.devices_attention,
                })}
              </div>
            ) : (
              <div>{t("prime.bubbleChat2")}</div>
            )}

            <div
              style={{
                position: "absolute",
                top: "20px",
                right: "-15px",
                width: "0",
                height: "0",
                borderStyle: "solid",
                borderWidth: "10px 10px 0 10px",
                borderColor: "#d4e0ee transparent transparent transparent",

                transform: "rotate(-90deg)",
              }}
            />
          </div>
        )}

        {/* Mona Avatar */}
        <div
          style={{
            backgroundColor: "#d4e0ee",
            color: textColor,
            width: "75px",
            height: "75px",
            overflow: "hidden",
            boxShadow: "2px 2px 3px rgba(0, 0, 0, 0.4)",
            borderRadius: "50%",
          }}
        >
          <img
            src={monaLogo}
            alt="Mona"
            style={{
              width: "75px",
              height: "75px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #d4e0ee",
            }}
          />
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
